export default "__VITE_ASSET__Drl_rCSR__"